const categoryIdPattern = /[?&]categoryId=([^&#]+)/;

/**
 * Facility links are merchant-configured, but the auth token must only ever
 * be appended to the configured application origin.
 */
export const isTrustedFacilityBookingUrl = (
  value: string,
  appUrl = import.meta.env.VITE_APP_URL || "",
): boolean => {
  try {
    const target = new URL(value);
    const expected = new URL(appUrl);
    const route = target.hash.replace(/^#/, "").split("?")[0];

    return (
      target.origin === expected.origin &&
      ["/facility", "/facility-list"].includes(route)
    );
  } catch {
    return false;
  }
};

export const getFacilityCategoryId = (url: string): string => {
  const match = url.match(categoryIdPattern);
  if (!match?.[1]) return "";

  try {
    return decodeURIComponent(match[1]);
  } catch {
    return match[1];
  }
};

/**
 * Preserves the legacy facility-booking URL shape, including hash-router
 * query parameters, while adding the authenticated webview context.
 */
export const buildFacilityBookingUrl = (
  url: string,
  params: { lang: string; token: string; singleActivity?: boolean },
): string => {
  const target = params.singleActivity
    ? url
    : url.replace("facility?", "facility-list?");
  const separator = target.includes("?") ? "&" : "?";
  const search = new URLSearchParams({
    lang: params.lang,
    token: params.token,
    iswebview: "true",
  });

  return target + separator + search.toString();
};
